exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-tabs-sticky[data-v-41c5c718]{background-color:#eee}.nav-link[data-v-41c5c718]{cursor:pointer}.bootstrap-dark .nav-tabs-sticky[data-v-41c5c718]{background-color:#343a40}", ""]);

// exports
